import { ByValuesSorter, GenericTuple } from "sort-es/lib/src/types/types";

export type SortClauses<T> = ByValuesSorter<T, GenericTuple<T>[]>;

/**
 * A function that returns sort clauses for a given column.
 * @template TData - The data type being sorted
 * @template TColumnId - The column identifier type (defaults to keyof TData)
 */
export type ColumnSorter<TData, TColumnId = keyof TData> = (
  columnId: TColumnId,
  desc: boolean,
) => SortClauses<TData>;

const alphabeticCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
});

export function nullableSort(desc = false) {
  return function sort<T = Date | number | string | boolean | null>(
    a: T,
    b: T,
  ): number {
    let result = 0;
    const orderMultiplier = desc ? 1 : -1;

    if (a === null || a === undefined) {
      result = orderMultiplier;
    } else if (b === null || b === undefined) {
      result = -orderMultiplier;
    } else {
      if (
        typeof a === "number" ||
        typeof b === "number" ||
        typeof a === "boolean" ||
        typeof b === "boolean"
      ) {
        result = Number(b) - Number(a);
      } else if (a instanceof Date && b instanceof Date) {
        result = b.getTime() - a.getTime();
      } else {
        result = alphabeticCollator.compare(b.toString(), a.toString());
      }
    }

    return result * orderMultiplier;
  };
}
